import Api from "api/Api";
import PageTitle from "components/common/PageTitle";
import SmallLoader from "components/common/SmallLoader";
import { DashboardChart } from "components/dashboard/DashboardCharts";
import DashboardCountCard from "components/dashboard/DashboardCountCard";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UserWrapper from "./user.style";

const Dashboard = props => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);
    Api.get(`/admin/dashboard`)
      .then(res => {
        if (res.status) {
          setData(res.data.data);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleReceiptClick = (el, isReceipt) => {
    if (!isReceipt) return;
    props.history.push(`/receipt`, el.name);
  };

  return (
    <UserWrapper {...props}>
      <div className="gt-dashboard plr-15">
        <PageTitle title={"sidebar.dashboard"} />

        {!!loading && (
          <div className="flex flex-1 flex-column fill-height pa-100 justify-content-center align-items-center">
            <SmallLoader />
          </div>
        )}

        {!loading && !!data && (
          <>
            <div className="gt-dashboard-stats">
              <DashboardCountCard
                title="Stores"
                count={data?.storeCount}
                icon="fas fa-store"
                variant="teal"
                onClick={() => props.history.push("/store")}
              />
              <DashboardCountCard
                title="Devices"
                count={data?.deviceCount}
                icon="fas fa-mobile-alt"
                variant="blue"
                onClick={() => props.history.push("/device")}
              />
              <DashboardCountCard
                title="Receipts"
                count={data?.receiptsCount}
                icon="fas fa-receipt"
                variant="violet"
                onClick={() => props.history.push("/receipt")}
              />
              <DashboardCountCard
                title="Users"
                count={data?.userCount}
                icon="fas fa-users"
                variant="amber"
                onClick={() => props.history.push("/user")}
              />
            </div>

            <div className="gt-dashboard-section">
              <h2 className="gt-dashboard-section__title">Analytics</h2>
              <div className="gt-dashboard-charts-row">
                <div className="gt-chart-card">
                  <div className="gt-chart-card__header">
                    <h3 className="gt-chart-card__title">App Users Platform</h3>
                    <p className="gt-chart-card__subtitle">
                      Breakdown by device OS
                    </p>
                  </div>
                  <div className="gt-chart-card__body">
                    <DashboardChart data={data?.deviceOSType} type="PIE" />
                  </div>
                </div>
                <div className="gt-chart-card">
                  <div className="gt-chart-card__header">
                    <h3 className="gt-chart-card__title">User Registration</h3>
                    <p className="gt-chart-card__subtitle">
                      Sign-up method distribution
                    </p>
                  </div>
                  <div className="gt-chart-card__body">
                    <DashboardChart data={data?.userRegType} type="PIE" />
                  </div>
                </div>
              </div>

              <div className="gt-chart-card gt-chart-card--wide">
                <div className="gt-chart-card__header">
                  <h3 className="gt-chart-card__title">Receipts</h3>
                  <p className="gt-chart-card__subtitle">
                    Unscanned vs scanned receipt types — click a segment to
                    filter
                  </p>
                </div>
                <div className="gt-chart-card__body">
                  <div className="gt-receipt-charts">
                    <div className="gt-receipt-charts__panel">
                      <div className="gt-receipt-charts__label">Unscanned</div>
                      <DashboardChart
                        data={data?.receiptType?.filter(
                          rec => rec.name === "UNSCANNED"
                        )}
                        type="PIE"
                        isReceipt={true}
                        handleReceiptClick={handleReceiptClick}
                        outerRadius={72}
                        innerRadius={44}
                      />
                    </div>
                    <div className="gt-receipt-charts__panel">
                      <div className="gt-receipt-charts__label">
                        Scanned types
                      </div>
                      <DashboardChart
                        data={data?.receiptType?.filter(
                          rec => rec.name !== "UNSCANNED"
                        )}
                        type="PIE"
                        isReceipt={true}
                        handleReceiptClick={handleReceiptClick}
                        outerRadius={88}
                        innerRadius={52}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, withRouter, null)(Dashboard);
